import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { throwError } from 'rxjs';
import { VayAntService } from './vay-ant.service';

@Injectable({
  providedIn: 'root'
})
export class MingoErrorsHandler implements ErrorHandler {
  constructor(private antService: VayAntService) {}
  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      // console.log('MingoErrorsHandler : ', error.error.message);
      this.antService.showMessage(error.error.message, 'error');
      // Server or connection error happened
      if (!navigator.onLine) {
        // Handle offline error
      } else {
        // Handle Http Error (error.status === 403, 404...)
      }
    } else {
      // Handle Client Error (Angular Error, ReferenceError...)
    }

    // Log the error anyway
    // console.error('It happens: ', error);
    return throwError(error.message);
  }
}
